<template>
    <crud-layout
        title="Vendedores"
        subtitle="Gestión de vendedores"
        :add-button="true"
        @add="create"
    >
        <template v-slot:list>
            <vendedor-list
                ref="list"
                @update="update"
                @delete="remove"
                @show="show"
            />
        </template>

        <vendedor-create
            v-if="creating"
            :open="creating"
            @itemCreated="onItemCreated"
            @close="creating = false"
        />

        <vendedor-update
            v-if="updating"
            :open="updating"
            :item="itemToEdit"
            @itemUpdated="onItemUpdated"
            @close="updating = false"
        />

        <vendedor-show
            v-if="showing"
            :open="showing"
            :item="itemToShow"
            @close="showing = false"
        />

        <vendedor-delete
            v-if="deleting"
            :open="deleting"
            :item="itemToDelete"
            @itemDeleted="onItemDeleted"
            @close="deleting = false"
        />

        <snackbar v-model="flash" />
    </crud-layout>
</template>

<script>
import VendedorCreate from "../VendedorCreate/VendedorCreate.vue";
import VendedorUpdate from "../VendedorUpdate/VendedorUpdate.vue";
import VendedorDelete from "../VendedorDelete/VendedorDelete.vue";
import VendedorShow from "../VendedorShow/VendedorShow.vue";
import VendedorList from "../VendedorList/VendedorList.vue";
import { CrudLayout, Snackbar } from "@dracul/common-frontend";

export default {
    name: "VendedorCrud",
    components: {
        CrudLayout,
        Snackbar,
        VendedorCreate,
        VendedorUpdate,
        VendedorDelete,
        VendedorShow,
        VendedorList,
    },
    data() {
        return {
            flash: null,
            creating: false,
            updating: false,
            deleting: false,
            showing: false,
            itemToEdit: null,
            itemToDelete: null,
            itemToShow: null,
        };
    },
    methods: {
        onItemCreated() {
            this.$refs.list.fetch();
            this.flash = "Vendedor creado";
        },
        onItemUpdated() {
            this.$refs.list.fetch();
            this.flash = "Vendedor actualizado";
        },
        onItemDeleted() {
            this.$refs.list.fetch();
            this.flash = "Vendedor eliminado";
        },
        create() {
            this.creating = true;
        },
        update(item) {
            this.updating = true;
            this.itemToEdit = item;
        },
        show(item) {
            this.showing = true;
            this.itemToShow = item;
        },
        remove(item) {
            this.deleting = true;
            this.itemToDelete = item;
        },
    },
};
</script>
